import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const ChangeLogDetails = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="breadcrumb-area  off-white-bc">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-12">
              <div className="breadcrumb-content web-realise-title">
                <h3>Change Log</h3>
                <p>
                  Always up to date! Manager is being continuously updated to
                  keep getting better than ever.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="web-realise-details">
        <div className="container">
          <div className="web-realise-details-inner">
            <div className="row">
              <div className="col-12">
                <div className="realise-details-head">
                  <div className="back-realise">
                    <Link to="/changelog">
                      <i className="fa fa-arrow-left"></i>Back to realises
                    </Link>
                  </div>
                  <div className="realise-details-date">
                    <ul>
                      <li className="date-dot">02 Oct, 2020</li>
                      <li>05:20PM</li>
                    </ul>
                  </div>
                </div>
                <div className="realise-details-content">
                  <h3>
                    Complete the paragraph’s idea or transition into the next
                    paragraph
                  </h3>
                  <p>
                    The final movement in paragraph development involves tying
                    up the loose ends of the paragraph and reminding the reader
                    of the relevance of the information in this paragraph to the
                    main or controlling idea of the paper. At this point, you
                    can remind your reader about the relevance of the
                    information that you just discussed in the paragraph. You
                    might feel more comfortable, however, simply transitioning
                    your reader to the next development in the next paragraph.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ChangeLogDetails;
